import React, { useState, useEffect } from "react";
//FBS  Landing Page - Optimized Version working on 28-05-2024 on the google form submit  gooogle  sheeet  working perfectly
// import { Link } from 'react-router-dom';
import '../../styles/OptimizedLandingPage.css';
import {postStudentEnquiry, getGalleryImages, getPlacedStudents } from '../../services/getAllApi';
// import { postStudentEnquiry, getGalleryImages, getPlacedStudents } from '../../services/getAllApi';
import { classRoom1, classRoom2, classRoom3 } from '../../assets/index';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../../styles/StudentReviews.css";
import '../../styles/PursueMBA.css';
import { QoteImage } from '../../assets/index';
import { getTestimonial } from '../../services/getAdminApi';
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { FaWhatsapp } from "react-icons/fa";

const OptimizedLandingPage = () => {
  const backgrounds = [classRoom1, classRoom2, classRoom3];
  const [currentBackground, setCurrentBackground] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [placedStudentData, setPlacedStudentData] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  const [activeTab, setActiveTab] = useState("sem1");

  const semesters = {
    sem1: {
      compulsory: [
        "Managerial Accounting",
        "Organizational Behavior",
        "Economics Analysis for Business",
        "Business Research Methodology",
        "Basics of Marketing",
        "Digital Business",
      ],
      electives: [
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Management Fundamentals",
            "Indian Economy",
            "Legal Aspects of Business",
            "Verbal Communication Lab",
            "MS Excel",
            "Entrepreneurship- Managing Skills for MSMEs-Seminar",
            "Desk Research- Best Business Practices-Case Study",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Verbal Communication Lab",
            "Enterprise Analysis & Desk Research",
            "Selling & Negotiation Skills Lab",
            "MS Excel",
            "Business Systems & Procedures",
            "Managing Innovation",
            "Foreign Language – I",
          ],
        },
      ],
    },
    sem2: {
      compulsory: [
        "Marketing Management",
        "Financial Management",
        "Human Resources Management",
        "Operations & Supply Chain Management",
        "Personal Financial Planning",
        "Financial Markets and Banking Operations",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "Contemporary Frameworks in Management",
            "Geopolitics & World Economic Systems",
            "Start Up and New Venture Management",
            "Qualitative Research Methods",
            "Business, Government & Society",
            "Business Process Re-engineering",
          ],
        },
        {
          note: "Maximum 1 course to be selected from the following list",
          subjects: [
            "Written Analysis and Communication Lab",
            "Industry Analysis & Desk Research",
            "Entrepreneurship Lab",
            "SPSS",
            "Foreign Language II",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Securities Analysis & Portfolio Management",
            "Futures and Options",
            "Direct Taxation",
            "Financial Reporting",
            "Retail Credit Management- Lending & Recovery",
            "Banking Laws & Regulations",
            "Fundamentals of Life Insurance – Products and Underwriting",
            "General Insurance - Health and Vehicle",
          ],
        },
      ],
    },
    sem3: {
      compulsory: [
        "Strategic Management",
        "Decision Science",
        "Summer Internship Project",
        "Advanced Financial Management",
        "International Finance",
      ],
      electives: [
        {
          note: "Any 3 courses to be selected from the following list",
          subjects: [
            "International Business Economics",
            "International Business Environment",
            "Project Management",
            "Quality Management",
            "Corporate Governance",
            "Management of Non-profit organizations",
          ],
        },
        {
          note: "Maximum 3 courses to be selected from the following list",
          subjects: [
            "Behavioral Finance",
            "Commodities Markets",
            "Indirect Taxation",
            "Corporate Financial Restructuring",
            "Financial Modeling",
            "FIN Digital Banking",
            "Treasury Management",
            "Project Finance and Trade Finance",
            "Insurance Laws & Regulations",
            "Marine Insurance",
            "Fire Insurance",
          ],
        },
      ],
    },
    sem4: {
      compulsory: [
        "Enterprise Performance Management",
        "Indian Ethos & Business Ethics",
        "Financial Laws",
        "Current Trends & Cases in Finance",
      ],
      electives: [
        {
          note: "Any 2 courses to be selected from the following list",
          subjects: [
            "Global Strategic Management",
            "Elective Competing in Global Markets",
            "Elective Cyber Laws",
            "CSR & Sustainability",
          ],
        },
        {
          note: "Maximum 2 courses to be selected from the following list",
          subjects: [
            "Fixed Income Securities",
            "Business Valuation",
            "Risk Management",
            "Strategic Cost Management",
            "Rural and Micro Finance",
            "Reinsurance",
            "Agricultural Insurance",
          ],
        },
      ],
    },
  };

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email_address: '',
    contact_number: '',
    course_interested: '',
    city: '',
    agree: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const fetchCompanyImages = async () => {
    try {
      const response = await getGalleryImages("RecruiterCompanies");
      setCompanies(Array.isArray(response.data.images) ? response.data.images : []);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };

  const CallplacedStudentData = async () => {
    getPlacedStudents()
      .then((res) => {
        if (res.status === 200) {
          setPlacedStudentData(res.data.slice().reverse())
        }
      })
  }

  useEffect(() => {
    fetchCompanyImages();
    CallplacedStudentData();
  }, []);

  useEffect(() => {
    console.log("ENV: ", "https://console.fbsedu.in/storage/app")
    // Fetch testimonials from API
    getTestimonial()
      .then((response) => {
        // If the response contains data, update the state
        if (response && response.data) {
          setTestimonials(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setFadeOut(true);
      setTimeout(() => {
        setCurrentBackground((prevIndex) => (prevIndex + 1) % backgrounds.length);
        setFadeOut(false);
      }, 250);
    }, 5000);

    return () => clearInterval(interval);
  }, [backgrounds.length]);

  const formatIndianPhoneNumber = (number) => {
    // Remove all non-digits and strictly limit to exactly 10 digits
    const digits = number.replace(/\D/g, '');
    return digits.slice(0, 10);
  };



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'contact_number') {
      const formattedValue = formatIndianPhoneNumber(value);
      setFormData(prevState => ({
        ...prevState,
        [name]: formattedValue
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await postStudentEnquiry(formData);
      if (response.status !== 201 && response.status !== 200) {
        throw new Error(JSON.stringify(response.response.data.message));
      }
      return true; // Success
    } catch (error) {
      console.error('Backend submission error:', error);
      throw new Error('Failed to submit to backend. Please try again.');
    }
  };

  // Combined form submission handler
  const handleCombinedSubmit = async (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    if (!formData.first_name || !formData.last_name || !formData.email_address ||
      !formData.contact_number || !formData.course_interested || !formData.city ||
      !formData.agree) {
      setError('Please fill in all fields and agree to the terms.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Submit to backend, Google Sheets, and webhook
      await Promise.all([handleSubmit(), handleGoogleSheetSubmit(), handleWebhookSubmit()]);

      // If both succeed, show success message and reset form
      setSuccessMessage('Your request has been successfully submitted!');
      setFormData({
        first_name: '',
        last_name: '',
        email_address: '',
        contact_number: '',
        course_interested: '',
        city: '',
        agree: false
      });
    } catch (error) {
      setError(error.message || 'An error occurred while submitting the form.');
    } finally {
      setLoading(false);
    }
  };

  // Submission handler for Google Sheets integration
  const handleGoogleSheetSubmit = async () => {
    try {
      const googleSheetUrl = 'https://script.google.com/macros/s/AKfycbxc1E6ue7z2z7IUKrSHunsRBjdH02fGo9zKhStqacZEjO-KFblFmMsmgbAFzP1F1rhZnQ/exec';
      const formDataToSend = new FormData();
      formDataToSend.append("first_name", formData.first_name);
      formDataToSend.append("last_name", formData.last_name);
      formDataToSend.append("email_address", formData.email_address);
      formDataToSend.append("contact_number", formData.contact_number);
      formDataToSend.append("course_interested", formData.course_interested);
      formDataToSend.append("city", formData.city);
      formDataToSend.append("agree", formData.agree);

      const response = await fetch(googleSheetUrl, {
        method: "POST",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error(`Sheets submission failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      if (result.result !== 'success') {
        throw new Error('Sheets submission returned failure');
      }

      // Push custom event to dataLayer for GTM to handle Google Ads conversion
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'form_submit_conversion',
          form_data: {
            first_name: formData.first_name,
            email: formData.email_address,
            phone: formData.contact_number,
            course: formData.course_interested,
            city: formData.city
          }
        });
      }

      return true; // Success
    } catch (error) {
      console.error('Google Sheets submission error:', error);
      throw new Error('Failed to submit to Google Sheets. Please try again.');
    }
  };

  // Submission handler for Webhook integration
  const handleWebhookSubmit = async () => {
    try {
      const webhookUrl = 'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTY0MDYzNTA0Mzc1MjZjNTUzMjUxM2Ei_pc';
      const payload = {
        first_name: formData.first_name,
        last_name: formData.last_name,
        contact_number: formData.contact_number,
        email_address: formData.email_address,
        city: formData.city,
        course_interested: formData.course_interested,
        url: window.location.href
      };

      const response = await fetch(webhookUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`Webhook submission failed: ${response.status} ${response.statusText}`);
      }

      return true; // Success
    } catch (error) {
      console.error('Webhook submission error:', error);
      throw new Error('Failed to submit to webhook. Please try again.');
    }
  };

  // const handleDownload = () => {
  //   const link = document.createElement("a");
  //   link.href = "/FBS Guaranteed Job MBA 2025.pdf";
  //   link.download = "FBS-Brochure.pdf";
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const handleWhatsApp = () => {
    const message = encodeURIComponent("Hi! I'm interested in the MBA Finance program at FBS. Can you provide more information?");
    window.open(`https://wa.me/919158882688?text=${message}`, '_blank');
  };

  // const handleCall = () => {
  //   window.location.href = 'tel:+919158882688';
  // };



  return (
    <div className="optimized-landing-page">
      {/* Topbar Header */}
      <div className="topbar flex flex-col sm:flex-row justify-between items-center p-1 pr-6 pl-4">
        {/* <div className="social-icons hidden sm:flex">
          <a href="https://www.instagram.com/finxl_business_school/" target="_blank" rel="noopener noreferrer">
            <i className='bx bxl-instagram' style={{ color: '#ff07cf' }}></i>
          </a>
          <a href="https://www.linkedin.com/company/fbs-finxl-business-school/" target="_blank" rel="noopener noreferrer">
            <i className='bx bxl-linkedin' style={{ color: '#0000a8' }}></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61561972892184" target="_blank" rel="noopener noreferrer">
            <i className='bx bxl-facebook' style={{ color: '#3b5998' }}></i>
          </a>
          <a href="https://api.whatsapp.com/send?phone=919158882688" target="_blank" rel="noopener noreferrer">
            <i className='bx bxl-whatsapp' style={{ color: '#00d100' }}></i>
          </a>
        </div> */}


        <div className="contact-info flex items-center">
          <i className='bx bxs-phone'></i>
          <a href="tel:9158882688" className='relative right-[1rem]'>
            915-888-2688
          </a>
          <i className='bx bxs-envelope'></i>
          <a href="mailto:admission@fbsedu.in" className="relative right-[0.8rem]">admission@fbsedu.in</a>
          <i className='bx bxs-map'></i>
          <a href="https://maps.app.goo.gl/p1C91ysjyFv2z88z8" target="_blank" rel="noopener noreferrer" className="relative right-[0.8rem]">Baner, Pune</a>
        </div>
      </div>

      {/* Logo Banner */}
      <div className="logo-banner">
        <div className="logo-container">
          <img
            src={require('../../assets/images/FBS_logo.png')}
            alt="FBS Logo"
            className="fbs-logo"
          />
          <div className="logo-text">
            <div className="banner-menu-container">
              <div className="banner-menu-item">
                <a href="#why-fbs-section" onClick={() => document.getElementById('why-fbs-section').scrollIntoView({ behavior: 'smooth' })}>Why FBS</a>
              </div>
              <div className="banner-menu-item">
                <a href="#testimonials-section" onClick={() => document.getElementById('testimonials-section').scrollIntoView({ behavior: 'smooth' })}>Success Stories</a>
              </div>
              <div className="banner-menu-item">
                <a href="#courses-section" onClick={() => document.getElementById('courses-section').scrollIntoView({ behavior: 'smooth' })}>Courses</a>
              </div>
              <div className="banner-menu-item">
                <a href="#faq-section" onClick={() => document.getElementById('faq-section').scrollIntoView({ behavior: 'smooth' })}>FAQ</a>
              </div>
              {/* Removed Contact Us from banner menu as per request */}
            </div>
            <div className="logo-cta-preview">
              <button className="preview-cta-btn" onClick={() => { document.getElementById('hero-section').scrollIntoView({ behavior: 'smooth' }); setError("Please fill the form in the hero section to apply and get more information."); }}>
                🎓 Enroll Now ! - Limited Seats!
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section id="hero-section" className="hero-section">
        <div
          className={`hero-background ${fadeOut ? "fade-out" : "fade-in"}`}
          style={{
            backgroundImage: `url(${backgrounds[currentBackground]})`,
          }}
        />
        <div className="hero-overlay" />

        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-badge">
              <span className="badge-text">🎓 GUARANTEED JOB MBA</span>
            </div>
            <h1 className="hero-title">
              Get a Finance MBA to Advance Your Career with a
              <span className="highlight"> Guaranteed Job Placement</span>
            </h1>
            <p className="hero-subtitle">
              With India's top business school, build a strong foundation in core finance field. Practical experience all supported by our 100% placement guarantee.
            </p>
            <div className="hero-benefits">
              <div className="benefit-item">
                <span className="benefit-icon">💼</span>
                <span>1 Year Job Experience</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">💰</span>
                <span>3.50 LPA - 22 LPA Packages</span>
              </div>
              <div className="benefit-item">
                <span className="benefit-icon">📚</span>
                <span>100+ Real Case Studies</span>
              </div>
            </div>

            {/* Mobile CTAs */}
            {/* <div className="mobile-ctas">
              <button onClick={handleWhatsApp} className="cta-whatsapp">
                <span>📱 WhatsApp Now</span>
              </button>
              <button onClick={handleCall} className="cta-call">
                <span>📞 Call Now</span>
              </button>
            </div> */}
          </div>

          <div className="hero-form">
            <div className="form-header">
              <h3>Start Your Journey Today!</h3>
              <p>Get FREE Career Consultation</p>
            </div>
            <form onSubmit={handleCombinedSubmit} className="enquiry-form">
              <div className="form-grid">
                <input
                  type="text"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleChange}
                  placeholder="First Name"
                  required
                />
                <input
                  type="text"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleChange}
                  placeholder="Last Name"
                  required
                />
                <input
                  type="tel"
                  name="contact_number"
                  value={formData.contact_number}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  maxLength="10"
                  pattern="[0-9]{10}"
                  title="Please enter exactly 10 digits"
                  required
                />
                <input
                  type="email"
                  name="email_address"
                  value={formData.email_address}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                />
                <select
                  name="course_interested"
                  value={formData.course_interested}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Course</option>
                  <option value="MBA in Finance">MBA in Finance</option>
                </select>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="City"
                  required
                />
              </div>

              <div className="form-consent">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={formData.agree}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="agree">
                  I agree to receive updates from FBS via email, call, WhatsApp & SMS
                </label>
              </div>

              {error && <div className="form-error">{error}</div>}
              {successMessage && <div className="form-success">{successMessage}</div>}

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Submitting...' : 'Start My MBA Journey'}
              </button>
            </form>

            {/* <button onClick={handleDownload} className="download-btn">
              📄 Download Brochure
            </button> */}
            <button onClick={() => { document.getElementById('hero-section').scrollIntoView({ behavior: 'smooth' }); setError("Please fill the form to receive the brochure and detailed information via email."); }} className="download-btn">
              📄 Download Brochure
            </button>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="social-proof">
        <div className="placed-students">
          <h4>Recent Placements</h4>
          <div className="students-scroll animate-scroll-left">
            {[...placedStudentData, ...placedStudentData].map((student, index) => (
              <div key={`student-${index}`} className="student-card">
                <img
                  src={`${"https://console.fbsedu.in/storage/app"}/${student.student_photo}`}
                  alt={student.student_name}
                />
                <div className="student-info">
                  <p className="student-name">{student.student_name}</p>
                  <img
                    src={`${"https://console.fbsedu.in/storage/app"}/${student.company_logo?.length > 0 ? student.company_logo : ''}`}
                    alt="Company"
                    className="company-logo"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="recruiter-logos">
          <h4>Our Recruiters</h4>
          <div className="logos-scroll animate-scroll-right">
            {[...companies, ...companies].map((image, index) => (
              <div key={`company-${index}`} className="logo-card">
                <img
                  src={`${"https://console.fbsedu.in/storage/app"}/${image.image_path}`}
                  alt="Company Logo"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Signals Section */}
      <section id="why-fbs-section" className="trust-signals">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose FBS?</h2>
          </div>
          <div className="trust-grid">
            <div className="trust-item">
              <div className="trust-icon">🏆</div>
              <h3>One Year of Experience in a Salaried Position</h3>
              <p>Get your career started with a placement guarantee and practical business experience.</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">💼</div>
              <h3>Offering Salary Packages</h3>
              <p>Make between ₹3.5 LPA and ₹22 LPA working with top recruiters in various industries.</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">📊</div>
              <h3>More than 100 Real-World Case Studies</h3>
              <p>Learn about finance through real-world projects, simulations and international case studies.</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">🎁</div>
              <h3>₹2.5 Lakh Worth of Free Benefits</h3>
              <p>Your MBA comes with special certifications, tools, and career training.</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Courses Section */}
      <section id="courses-section" className="about-courses">
        <div className="container">
          <div className="section-header">
            <h2>Our Programs</h2>
            <p>Discover our transformative MBA programs designed for career growth with guaranteed placements.</p>
          </div>
          <div className="courses-grid">
            <div className="course-card">
              <div className="course-icon">💼</div>
              <h3>MBA in Finance</h3>
              <p>The MBA in Finance is a 2-year full-time program designed to equip students with essential financial skills and industry knowledge. The program includes real-time case studies, expert mentorship, resume-building support, and lifetime access to the FINXL LMS.</p>
              <p>FBS offers a <strong>guaranteed placement</strong> in the core finance sector along with a <strong>one-year job experience letter</strong>, ensuring strong career growth. Enjoy an attractive return on investment with competitive salary packages and long-term career opportunities in finance.</p>

              <div className="syllabus-section">
                <h4>MBA Finance Syllabus</h4>
                <p>This syllabus is crafted to give you a competitive edge. Explore the courses across semesters.</p>
                <div className="semester-tabs">
                  {Object.keys(semesters).map((semKey, index) => (
                    <button
                      key={semKey}
                      className={`tab-btn ${activeTab === semKey ? 'active' : ''}`}
                      onClick={() => setActiveTab(semKey)}
                    >
                      SEMESTER {index + 1}
                    </button>
                  ))}
                </div>
                <div className="tab-content">
                  <div className="overflow-x-auto">
                    <table className="syllabus-table w-full border-collapse">
                      <thead>
                        <tr>
                          <th>Semester</th>
                          <th>Subject</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {semesters[activeTab] && (
                          <>
                            <tr>
                              <td>SEMESTER {activeTab.slice(-1).toUpperCase()}</td>
                              <td>
                                <ul className="list-disc list-inside">
                                  {semesters[activeTab].compulsory.map((subject, idx) => (
                                    <li key={idx}>{subject}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>Compulsory</td>
                            </tr>
                            {semesters[activeTab].electives.map((elective, idx) => (
                              <React.Fragment key={idx}>
                                <tr className="bg-gray-50">
                                  <td colSpan={3} className="text-center font-semibold">
                                    {elective.note}
                                  </td>
                                </tr>
                                <tr>
                                  <td>SEMESTER {activeTab.slice(-1).toUpperCase()}</td>
                                  <td>
                                    <ul className="list-disc list-inside">
                                      {elective.subjects.map((subject, subIdx) => (
                                        <li key={subIdx}>{subject}</li>
                                      ))}
                                    </ul>
                                  </td>
                                  <td>Electives</td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="course-buttons">
                <button className="course-apply" onClick={() => { document.getElementById('hero-section').scrollIntoView({ behavior: 'smooth' }); setError("Please fill the form in the hero section to apply and get more information."); }}>Apply Now</button>
                {/* <button className="course-know-more" onClick={() => document.querySelector('.hero-form').scrollIntoView({ behavior: 'smooth' })}>Know More</button> */}
              </div>
            </div>
            
          </div>
          <div className="courses-features">
            <h3>Key Highlights</h3>
            <ul>
              <li>1.5 years of experience</li>
              <li>15+ Professional Certifications</li>
              <li>100% Placement Guarantee</li>
              <li>100+ Real Case Studies</li>
              <li>Industry Visits & Interactions</li>
              <li>Project Assignments & Business Plan Development</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials-section" className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2>Success Stories</h2>
          </div>
          <div className="testimonial-slider-container">
            {/* Swiper component to display testimonials */}
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              pagination={{ clickable: true }}
              navigation={true}
              autoplay={{
                delay: 3000, // Auto-slide every 3 seconds
                disableOnInteraction: false, // Keep autoplay running even after interaction
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              modules={[Pagination, Navigation, Autoplay]}
              className="testimonial-swiper"
            >
              {/* Map over the testimonials data and render them */}
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={testimonial.id}>
                  <div className="testimonial-card">
                    <div className="quote">
                      <img src={QoteImage} alt="Quotes Icon" className="qicon" />
                    </div>
                    {/* Render student photo */}
                    <img
                      className="avatar"
                      src={`${"https://console.fbsedu.in/storage/app"}/${testimonial.student_photo}`}
                      alt={`${testimonial.student_name}'s avatar`}
                    />

                    <p className="testimonial-text">{testimonial.description}</p>

                    <p className="name">{testimonial.student_name}</p>

                    <p className="role">{testimonial.company_name}</p>
                    <div className="logos">

                      <div className="company-logo-container">
                        <img
                          className="company-logo"
                          src={`${"https://console.fbsedu.in/storage/app"}/${testimonial.company_logo}`}
                          alt={`${testimonial.company_name} logo`}
                        />
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq-section" className="faq-section">
        <div className="container">
          <div className="section-header">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>Is there a genuine job guarantee ?</h3>
              <p>Absolutely! FBS provides one year of paid corporate experience along with a 100% job placement guarantee. With salaries ranging from ₹3.5 LPA to ₹22 LPA, our students are employed by top companies.</p>
            </div>
            <div className="faq-item">
              <h3>Can working professionals join?</h3>
              <p>Indeed! Both recent graduates and working professionals are intended to benefit from our MBA in Finance program. You can balance work and study because of to flexible schedules and online resources.</p>
            </div>
            <div className="faq-item">
              <h3>What is the eligibility criteria</h3>
              <p>Candidates must have at least a 50% bachelor's degree in any field. Our Executive MBA program does not require an entrance exam.</p>
            </div>
            <div className="faq-item">
              <h3>Do you provide assistance in placement?</h3>
              <p>Absolutely. Every student is guaranteed employment opportunities with a dedicated placement cell and partnerships with 50+ leading companies.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      {/* <section className="final-cta">
        <div className="container">
          <div className="section-header">
            <h2>Ready to Transform Your Career?</h2>
            <p>Join thousands of successful professionals who chose FBS</p>
          </div>
          <div className="cta-buttons">
            <button onClick={handleWhatsApp} className="cta-primary">
              📱 Get Started Now
            </button>
            <button onClick={handleCall} className="cta-secondary">
              📞 Call for Details
            </button>
          </div>
        </div>
      </section> */}

      {/* footer */}
      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-section">
            
            <h4><i className='bx bxs-map'></i>Address</h4>
            <p><a href="https://maps.app.goo.gl/hxdCRp1pLbNUsDcw7" target="blank">301, Magnolia Business Center, Behind Star Market, Baner Pashan Link Road, Baner, Pune, Maharashtra, India 411021</a></p>
          </div>
          <div className="footer-section">
            <h4><i className='bx bxs-phone'></i>Phone Numbers</h4>
            <p><a href="tel:+919661626371">+91 96 61 62 63 71</a></p>
            <p><a href="tel:+918109240909">+91 81 09 24 09 09</a></p>
            <p><a href="tel:+919158882688">+91 91 58 88 26 88</a></p>
            <p><a href="tel:+919661626380">+91 96 61 62 63 80</a></p>
          </div>
          <div className="footer-section">
            <h4><i className='bx bxs-envelope'></i>Email</h4>
            <p><a href="mailto:admission@fbsedu.in">admission@fbsedu.in</a></p>
            <p><a href="mailto:admission1@finxl.in">admission1@finxl.in</a></p>
            <p><a href="mailto:admission2@finxl.in">admission2@finxl.in</a></p>
          </div>
        </div>
      </footer>

      <section className="footer-note">
        <ul>
          <li>© 2025-2026 FBS. All rights reserved.</li>
          <li><a href="/terms">| Terms and Conditions</a></li>
          <li><a href="/placment-policy">| Privacy Policy</a></li>
        </ul>
      </section>

      {/* Floating WhatsApp Button */}
      <div className="floating-whatsapp">
        <button onClick={handleWhatsApp} className="whatsapp-float">
          <FaWhatsapp size={28} />
        </button>
      </div>
    </div>
  );
};

export default OptimizedLandingPage;
